import React, { useEffect, useState } from "react";
import { Tooltip } from "@mantine/core";

interface CompassType {
  degrees: number;
}

function Compass({ degrees }: CompassType) {
  const tooltipStyles = {
    tooltip: {
      backgroundColor: "white",
      color: "#323232",
      fontSize: "12px",
    },
  };

  useEffect(() => {
    const compass = document.getElementById("compass");
    if (compass) {
      compass.style.transform = `rotate(${degrees}deg)`;
    }
  }, [degrees]);
  return (
    <Tooltip label="เข็มทิศ" position="left" styles={tooltipStyles}>
      <div className="bg-primary-contrast duration-300 w-8 h-8 p-[6px] rounded-[10px] border-[1px] border-gray-1  flex gap-2 cursor-pointer">
        <div id="compass">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.7089 11.1243C12.8489 10.9827 12.8963 10.8041 12.968 10.5792L15.2264 3.77277C15.3767 3.31589 15.3312 3.07874 15.1408 2.88632C14.9504 2.6939 14.7194 2.6515 14.2674 2.8034L7.52968 5.08248C7.30726 5.16206 7.13055 5.20997 6.99048 5.35154C6.73135 5.61345 6.77142 5.97958 7.08393 6.29544L11.7714 11.0262C12.0839 11.3421 12.4497 11.3862 12.7089 11.1243Z"
              fill="#E45151"
            />
            <path
              d="M5.54503 6.8125C5.40496 6.95408 5.35756 7.13268 5.28592 7.35758L3.02747 14.164C2.87719 14.6209 2.92272 14.858 3.1131 15.0504C3.30348 15.2429 3.53452 15.2853 3.98654 15.1334L10.7242 12.8543C10.9466 12.7747 11.1234 12.7268 11.2634 12.5852C11.5226 12.3233 11.4825 11.9572 11.17 11.6413L6.48249 6.91058C6.16998 6.59471 5.80416 6.55059 5.54503 6.8125Z"
              fill="#8E8E8E"
            />
          </svg>
        </div>
      </div>
    </Tooltip>
  );
}
export default Compass;
